import { Day } from "@/types/Day";

export enum GraphTypes {
	Line,
	Column,
	Table,
	Pie,
	Donut
}

export interface ReportState {
	AvailableReports: any[];
	Report: any;
	RelativeDaysToReport: number;
	CurrentReportUrl: string;
	ResultCount: number;
	ReportLoadingStatus: boolean;
	ReportErrorStatus: boolean;
	ReportApiEndpoint: string;
	ReportTypes: any[];
	ReportDateFormatPref: boolean;
	CustomReportModal: CustomReportModal;
	ShareCustomReportModal: ShareCustomReportModal;
	ShareWithUsers: ShareWithUsers[];
	FavoriteReportModal: FavoriteReportModal;
	FavoriteReports: ReportFavoriteData[];
	ReportHistoryModal: ReportHistoryModal;
}

export interface CustomReportModal {
	shown: boolean;
	insightID: number;
	isShared: boolean;
}

export interface ShareCustomReportModal {
	shown: boolean;
	insightID: number;
	reportName: string;
}

export interface FavoriteReportModal {
	shown: boolean;
	favoriteID: number;
	currentUrl: string;
	reportPermalink: string;
}

export interface ReportHistoryModal {
	shown: boolean;
}

export interface InsightSharesData {
	publicShare: boolean;
	expiryDate: Date | null;
}

export interface FilterOptionData {
	title: string;
	id: number | string;
}

export interface FilterId {
	id: number;
}

export interface SelectedFilters {
	groupId: [];
	responseId: [];
	eventTypeId: [];
	userId: [];
	eventOutcomeId: [];
	serverTypeEventNum: [];
	excludeAutoHandled: FilterOptionData;
	resultCount: FilterOptionData;
	startDate: string;
	endDate: string;
	dynamicdata?: [FilterId];
	excludeParkedTime: FilterOptionData;
	ignoreDateTime: FilterOptionData;
}

export interface ReportTypes {
	title: string;
	types: Types[];
}

export interface Types {
	category: string;
	drilldown: string;
	endpoint: string;
	insightID: number;
	templatable: boolean;
	name: string;
	customScript: string;
	defaultGraphType: number;
	customTitle: string;
	title: string;
}

export interface ReportTitles {
	title: string;
	customTitle: string;
}

export interface ReportFilterQuery {
	endpoint: string;
	query: string;
	filterName: string;
	data?: any;
}

export interface ReportUpdateFilterQuery {
	endpoint: string;
	query: {
		queries: FilterOptionData[];
	};
	filterName: string;
	data?: any;
}
export interface ReportPayload {
	groupingType: string | string[];
	timeZone: string;
	multiFilters: any;
	complexMultiFilters: any;
	dateFilters: any;
	idFilters: any;
	reportUrl: any;
	text: any;
	relativeDays?: number;
	dayFilters?: Day[] | undefined;
	excludedFilters?: any[];
	reportPermaLink: string;
	isPlugin: boolean;
}
export interface ShareWithUsers {
	shareSearchID: string;
	userID: number;
	userGroupID: number;
	name: string;
	email: string;
	initials: string;
}
export interface InsightSharesData {
	insightID: number;
	publicShare: boolean;
	expiryDate: Date | null;
	sharedWith: ReportSharedWith[];
}
export interface ReportSharedWith {
	id: number;
	title: string;
	isGroup: boolean;
	initials: string;
}
export interface ReportFavoriteData {
	insightsFavoriteID: number;
	name: string;
	userID: number;
	insightID: number;
	queryString: string;
}
